
import styled from "styled-components"

const Container = styled.button`
  background-color: ${({bgColor})=> bgColor};
  color: ${({color,theme})=> color === "flex" ? theme.mainTextColor : color};
  border-radius: ${({radius})=> radius};
  width: ${({width})=> width};
  padding: ${({padding})=> padding};
  font-size: ${({fontSize})=> fontSize};
  text-align: center;
  height: ${({height})=> height};
  font-weight: ${({fontWeight}) => fontWeight};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid;
  border-color: ${({borderColor}) => borderColor};
  cursor: ${({cursor}) => cursor};
`

const Btn = ({children, width, bgColor="transparent", borderColor="#E85446", height="40px", padding="0", fontSize="14px", fontWeight="600", radius="10px", handleClick, color="#fff", cursor="pointer", isDisabled=false }) => {
  return (
    <Container width={width} padding={padding} bgColor={bgColor} borderColor={borderColor} fontSize={fontSize} radius={radius} height={height} fontWeight={fontWeight} onClick={handleClick} color={color} cursor={isDisabled ? "not-allowed" : cursor} disabled={isDisabled}>
        {children}
    </Container>
  )
}

export default Btn